/**
 * The uniforms every stylized material shares: the clock, the wind, and the light as the camera
 * sees it. One object for all of them, so a frame updates them once.
 */
import * as THREE from 'three';

/** Linear colours of the stylized light: a warm sun, a cool sky and a warm ground bounce. */
export const styleUniforms = {
  uTime: { value: 0 },
  /** 0 is still air, 1 the normal breeze. */
  uWind: { value: 1 },
  /** 0 stills the water's ripples and foam. */
  uWaterMotion: { value: 1 },
  /** Towards the sun, in view space. */
  uSunDir: { value: new THREE.Vector3(0, 1, 0) },
  /** The sky's up, in view space. */
  uUpDir: { value: new THREE.Vector3(0, 1, 0) },
  uSunColor: { value: new THREE.Color(0.8, 0.72, 0.58) },
  uSkyColor: { value: new THREE.Color(0.4, 0.45, 0.56) },
  uGroundColor: { value: new THREE.Color(0.2, 0.18, 0.16) },
  uRimColor: { value: new THREE.Color(0.36, 0.44, 0.56) },
};

export type StyleUniforms = typeof styleUniforms;

const _dir = new THREE.Vector3();

/** Once a frame, after the camera moved: the clock, and where the sun and the sky's up are on screen. */
export function updateStyle(
  seconds: number,
  camera: THREE.Camera,
  sun: THREE.DirectionalLight,
): void {
  styleUniforms.uTime.value = seconds;
  _dir.copy(sun.position).sub(sun.target.position).normalize();
  styleUniforms.uSunDir.value.copy(_dir).transformDirection(camera.matrixWorldInverse);
  styleUniforms.uUpDir.value.set(0, 1, 0).transformDirection(camera.matrixWorldInverse);
}

/** Wind and water motion on or off (quality tiers, reduced motion). */
export function setMotion(wind: boolean, water: boolean): void {
  styleUniforms.uWind.value = wind ? 1 : 0;
  styleUniforms.uWaterMotion.value = water ? 1 : 0;
}
